var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificheIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.224,
    height: 14.956,
    viewBox: "0 0 13.224 14.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-notification-2528197",
    transform: "translate(-31.365 -29.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9648",
    "data-name": "Tracciato 9648",
    d: "M37.939,43.232h2.341a2.442,2.442,0,0,1-2.306,1.561,2.477,2.477,0,0,1-2.306-1.561Zm5.995-3.263c-2.554-1.454-.78-5.782-2.377-8.017a3.9,3.9,0,0,0-2.519-1.6c0-.674-2.128-.709-2.128,0a4.1,4.1,0,0,0-2.519,1.6c-1.6,2.235.177,6.562-2.377,8.017-.922.5-.887,2.164.248,2.27H43.721C44.821,42.133,44.856,40.5,43.934,39.969Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificheIcon);
export default __webpack_public_path__ + "static/media/notifiche_icon.a34c5da58c4708d88be9c1a4849bfdbc.svg";
export { ForwardRef as ReactComponent };